import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: _ctx.computedValor,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValor) = $event)),
    mode: "multiple",
    style: {"width":"100%"},
    placeholder: "Selecione por qual campo filtrar",
    options: _ctx.opcoes,
    disabled: _ctx.disabled,
    "allow-clear": ""
  }, null, 8, ["value", "options", "disabled"]))
}